import { unselectable } from '@rover/react-bootstrap'
import jwtDecode from 'jwt-decode'
import React, { Component } from 'react'
import { fetchQuery, graphql } from 'relay-runtime'
import environment, {
    getJudoTokenFromURL,
    isRunningInIframe,
    JUDO_SESSION_KEY,
    saveJudoToken,
} from '../relay/Environment'
import AppQueryRenderer from './AppQueryRenderer'
import MainNav from './MainNav'

class App extends Component {
    constructor() {
        super()
        this.state = {
            name: '',
            platformFeatures: [],
            platformVersion: 2,
        }
        this.getToken = this.getToken.bind(this)
        this.handleSignOut = this.handleSignOut.bind(this)
    }

    componentWillMount() {
        const storageKey = 'ember_simple_auth:session'
        let token = getJudoTokenFromURL()

        if (token) {
            saveJudoToken(token)
        } else {
            window.addEventListener('storage', event => {
                if (event.key === storageKey && !this.getToken() && !isRunningInIframe()) {
                    window.location.replace('/auth/sign-in')
                }
            })

            token = this.getToken()
            if (!token && !isRunningInIframe()) {
                window.location.replace('/auth/sign-in')
            }
        }

        let jwtDecoded
        try {
            jwtDecoded = jwtDecode(token)
        } catch (e) {
            if (!isRunningInIframe()) {
                window.location.replace('/auth/sign-in')
            }
        }
        const userId = jwtDecoded.sub

        const query = graphql`
            query AppQuery($id: ID!) {
                user(id: $id) {
                    name
                    account {
                        platformFeatures
                        platformVersion
                    }
                }
            }
        `
        const variables = {
            id: userId,
        }

        fetchQuery(environment, query, variables).then(data => {
            if (!data.user.account.platformFeatures.includes('campaigns')) {
                location.replace('/experiences')
            }

            this.setState({
                name: data.user.name,
                platformFeatures: data.user.account.platformFeatures,
                platformVersion: data.user.account.platformVersion,
            })
        })
    }

    getToken() {
        const session = JSON.parse(localStorage.getItem('ember_simple_auth:session'))
        return session ? session.authenticated.token : null
    }

    handleSignOut() {
        localStorage.removeItem('ember_simple_auth:session')
        sessionStorage.removeItem(JUDO_SESSION_KEY)
        if (!this.getToken()) {
            window.location.replace('/auth/sign-in')
        }
    }

    render() {
        const { name, platformFeatures, platformVersion } = this.state
        return (
            <div
                style={{
                    ...unselectable,
                    height: '100%',
                    widht: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                {!isRunningInIframe() && (
                    <MainNav
                        name={name}
                        platformFeatures={platformFeatures}
                        platformVersion={platformVersion}
                        isGimbalEnabled={false}
                        isXenioEnabled={false}
                        onRequestSignOut={() => this.handleSignOut()}
                    />
                )}
                <AppQueryRenderer platformFeatures={platformFeatures} />
            </div>
        )
    }
}

export default App
